import { snapshot } from 'valtio'
import { buildAxiosInstance } from '../../utils/apiUtils'
import { type GlobalCustomerCardType } from '../../types/GlobalCustomerCardType'
import { cardAddProxy } from './cardAddProxy'

interface Response {
  data: {
    customerCard: GlobalCustomerCardType
  } | null
  error: string | null
}

interface Props {
  customerId?: string
}
export async function apiExecuteCustomerCardCreate ({ customerId }: Props): Promise<GlobalCustomerCardType | undefined> {
  cardAddProxy.apiCallCustomerCardCreate.loading = true
  cardAddProxy.apiCallCustomerCardCreate.error = null
  const { converge, formValues } = snapshot(cardAddProxy)

  try {
    const axiosInstance = buildAxiosInstance()
    const response = await axiosInstance.post<Response>('/api/customer_cards/create', {
      billingAddressOne: formValues.streetAddressOne,
      billingAddressTwo: formValues.streetAddressTwo ?? null,
      billingCity: formValues.city,
      billingCountryCode: formValues.countryCode,
      billingPostalCode: formValues.postalCode,
      billingState: formValues.state,
      cardBrand: converge.cardBrand,
      cardName: `${converge.cardBrand || ''}-${(converge.cardNumber || '').slice(-4)}`,
      cardNumber: converge.cardNumber,
      cardType: converge.cardType,
      customerId,
      expirationMonth: converge.expDate?.substring(0, 2),
      expirationYear: parseInt(`20${String(converge.expDate?.substring(2, 4))}`),
      isPrimary: formValues.isPrimary,
      ppCardToken: converge.cardToken
    })
    if (response.data.data) {
      return response.data.data.customerCard
    } else {
      cardAddProxy.apiCallCustomerCardCreate.error = response.data.error
    }
  } catch (e) {
    if (e instanceof Error) {
      cardAddProxy.apiCallCustomerCardCreate.error = e.message
    }
  } finally {
    cardAddProxy.apiCallCustomerCardCreate.loading = false
  }
}
